/**
 * Environment utility functions
 * Checks both NODE_ENV and custom APP_ENV variable
 */

/**
 * Check if the app is running in production mode
 * @returns {boolean} True if in production
 */
export const isProduction = () => {
    // Check custom APP_ENV variable first (from .env files)
    const appEnv = process.env.REACT_APP_ENV || process.env.APP_ENV;
    if (appEnv) {
        return appEnv.toUpperCase() === 'PRODUCTION';
    }

    // Fallback to NODE_ENV
    return process.env.NODE_ENV === 'production';
};

/**
 * Check if the app is running in development mode
 * @returns {boolean} True if in development
 */
export const isDevelopment = () => {
    return !isProduction();
};

/**
 * Get the current environment name
 * @returns {string} Environment name (production, development, staging, etc.)
 */
export const getEnvironment = () => {
    return process.env.REACT_APP_ENV ||
        process.env.APP_ENV ||
        process.env.NODE_ENV ||
        'development';
};
